// extracted by mini-css-extract-plugin
module.exports = {"item":"selectArea_item__1Y_iP","clearBtn":"selectArea_clearBtn__18QES"};